import { uniq } from "lodash";
import { useMemo } from "react";
import { makeHook } from "../../utils/makeSingleArgHook";
import getSecuritiesBySecurityIds, { url, } from "../requests/getSecuritiesBySecurityIds";
export const getSecuritiesBySecurityIdsKeyMaker = (securityIds) => [url(securityIds)];
const useSecuritiesBySecurityIdsRaw = makeHook(getSecuritiesBySecurityIds, getSecuritiesBySecurityIdsKeyMaker);
export default function useSecuritiesBySecurityIds(ids, auth) {
    // Many consumers send in a lot of duplicate security ids
    const uniqueIds = useMemo(() => (ids === null ? null : uniq(ids)), [ids]);
    const securitiesBySecurityIds = useSecuritiesBySecurityIdsRaw(uniqueIds, auth);
    return securitiesBySecurityIds;
}
//# sourceMappingURL=useSecuritiesBySecurityIds.js.map